import { Component } from '@angular/core';

@Component({
  selector: 'app-devservices',
  imports: [],
  templateUrl: './devservices.component.html',
  styleUrl: './devservices.component.scss'
})
export class DevservicesComponent {

}
